import { Patient } from 'services/APIs';

/**
 * The backend reports a patient as unbookable when they already have an
 * appointment at the requested time. The frontend ignores that reason, so a
 * patient blocked only by a same-time appointment is treated as bookable.
 * Every other block, such as an upcoming appointment within the clinic's
 * window, is kept as the backend reported it.
 */
export const resolveSameTimeBookability = (patient: Patient): Patient => {
  const isBlockedOnlyBySameTimeAppt =
    patient.isBookable === false &&
    patient.isExistingApptWithinRequestedTime === true &&
    patient.isExistingApptWithinDays !== true;

  if (!isBlockedOnlyBySameTimeAppt) return patient;

  return { ...patient, isBookable: true };
};
